import { render, staticRenderFns } from "./AlbumImage.vue?vue&type=template&id=1556209e&scoped=true"
import script from "./AlbumImage.vue?vue&type=script&lang=js"
export * from "./AlbumImage.vue?vue&type=script&lang=js"
import style0 from "./AlbumImage.vue?vue&type=style&index=0&id=1556209e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556209e",
  null
  
)

export default component.exports